<template>
  <div class="Team">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path: '/team'}">机构信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news">
      <div class="block block1">
        <div class="title">
          <div>单位简介</div>
        </div>
        <div class="content">上海市消防救援总队主要承担《中华人民共和国消防法》及其他相关法律法规赋予的火灾预防、消防监督执法、灭火和应急救援等社会管理、公共服务职能。</div>
      </div>
      <div class="block block2">
        <div class="leader">
          <div class="title">
            <div>领导信息</div>
          </div>
          <div class="content">
            <div v-for="(item, index) in leader" :key="index" class="item" @click="goLeader(item)">
              <div class="label">{{item.subject}}</div>
              <div class="name">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="intro">
          <div class="title">
            <div>机构职能</div>
          </div>
          <div class="content">
            （一）承担灭火救援、特种灾害救援等综合性救援职责，协同组织其他自然灾害和事故灾难抢险救援等工作，指挥调度相关灾害事故救援行动。
            <br />（二）负责综合性消防救援预案编制、战术研究和执勤备勤、训练演练等工作。负责消防救援信息化和应急通信建设，承担消防救援行动应急通信保障工作。
            <br />（三）依法开展火灾预防、消防监督管理和综合协调、消防监督执法、重大活动消防安全保卫以及火灾事故调查处理有关工作，推动落实消防安全责任制。
            <br />（四）参与起草地方性消防法规、规章草案，参与拟订地方消防规划并监督实施。组织指导消防宣传教育，承担新闻宣传、舆情应对等工作。
            <br />（五）负责职责范围内的总队以下单位建设、管理工作。承担队伍教育训练有关工作。
            <br />（六）规范建设管理地方政府专职消防队伍，将地方政府专职消防队伍纳入国家消防救援力量统筹规划布局，实行统一指挥、统一纪律、统一训练、统一荣誉。建立与防汛抗旱、安全生产等专业应急救援队伍、志愿者队伍共训共练、救援合作等机制并组织实施。
            <br />（七）完成应急管理部、国家消防救援局与上海市党委和政府交办的其他任务。
          </div>
        </div>
      </div>
      <div class="block block3">
        <div class="title">
          <div>内设机构</div>
        </div>
        <div class="sub_title">机关内设机构</div>
        <div class="content">
          <div
            v-for="(item, index) in office1"
            :key="index"
            class="item"
            @click="goOffice(item)"
          >{{item.name}}</div>
        </div>
        <div class="sub_title">局直管单位</div>
        <div class="content">
          <div v-for="(item, index) in office2" :key="index" class="item">{{item.name}}</div>
        </div>
        <div class="sub_title">消防救援局及直属单位</div>
        <div class="content">
          <div v-for="(item, index) in office3" :key="index" class="item">{{item.name}}</div>
        </div>
      </div>
      <div class="block block4">
        <div class="title">
          <div>地理位置</div>
        </div>
        <div class="content">
          <div class="address">
            地址：上海市长宁区中山西路229号
            <br />邮编：200051
            <br />咨询热线：021-28955119或021-52738119
          </div>
          <img :src="require('@/assets/images/team_map.png')" />
          <div class="address">
            地址：上海市长宁区中山西路229号
            <br />邮编：200051
            <br />咨询热线：021-28955119或021-52738119
          </div>
        </div>
      </div>
      <div class="only_pc">
        <div class="tools">
          <div class="tools_item" @click="savePage">保存本页</div>
          <div class="tools_item" @click="printPage">打印本页</div>
          <div class="tools_item" @click="closePage">关闭窗口</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import teamData from "@/utils/teamData";

export default {
  name: "Team",
  mounted() {
    this.loadData();
  },
  data() {
    return {
      leader: [],
      office1: [],
      office2: [],
      office3: []
    };
  },
  methods: {
    loadData() {
      this.leader = teamData.leader;
      this.office1 = teamData.office;
      this.office2 = [{ name: "应急通信与车辆勤务大队" }];
      this.office3 = [
        { name: "黄浦区消防救援支队" },
        { name: "徐汇区消防救援支队" },
        { name: "长宁区消防救援支队" },
        { name: "静安区消防救援支队" },
        { name: "普陀区消防救援支队" },
        { name: "虹口区消防救援支队" },
        { name: "杨浦区消防救援支队" },
        { name: "闵行区消防救援支队" },
        { name: "宝山区消防救援支队" },
        { name: "嘉定区消防救援支队" },
        { name: "浦东新区消防救援支队" },
        { name: "金山区消防救援支队" },
        { name: "松江区消防救援支队" },
        { name: "青浦区消防救援支队" },
        { name: "奉贤区消防救援支队" },
        { name: "崇明区消防救援支队" },
        { name: "上海化学工区消防救援支队" },
        { name: "上海市消防救援总队特勤支队" },
        { name: "上海市消防救援总队轨道交通支队" },
        { name: "上海市消防救援总队水上支队" },
        { name: "上海市消防救援总队训练和战勤保障支队" }
      ];
    },
    goLeader(item) {
      window.open("/team/leader/" + item.id);
    },
    goOffice(item) {
      window.open("/team/office/" + item.id);
    },
    savePage() {
      let data = document.getElementsByTagName("html")[0].outerHTML,
        urlObject = window.URL || window.webkitURL || window,
        exportBlob = new Blob([data]),
        saveLink = document.createElementNS(
          "http://www.w3.org/1999/xhtml",
          "a"
        ),
        ev = document.createEvent("MouseEvents");
      saveLink.href = urlObject.createObjectURL(exportBlob);
      saveLink.download = "news" + this.id + ".html";
      ev.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      saveLink.dispatchEvent(ev);
    },
    printPage() {
      window.print();
    },
    closePage() {
      window.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.Team {
  padding-top: 40px;
  padding-bottom: 60px;
  @include body_block;
  @media (max-width: $mob-screen) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .breadcrumb {
    margin-bottom: 20px;
    @media (max-width: $mob-screen) {
      margin-bottom: 8px;
    }
    @media print {
      display: none;
    }
    .el-breadcrumb {
      line-height: 28px;
      font-size: 20px;
      @media (max-width: $mob-screen) {
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
  .news {
    background: #fff;
    padding: 36px 40px;
    @media (max-width: $mob-screen) {
      padding: 16px;
    }
    .block {
      .title {
        border-bottom: 1px solid rgba(22, 49, 112, 0.2);
        @include flex_start_start;
        div {
          padding: 0 5px 7px 5px;
          border-bottom: 4px solid #163170;
          line-height: 29px;
          font-size: 20px;
          color: #163170;
          font-weight: bold;
          @media (max-width: $mob-screen) {
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
      .content {
        margin-top: 28px;
        line-height: 28px;
        font-size: 16px;
        color: #242424;
        @media (max-width: $mob-screen) {
          margin-top: 16px;
          line-height: 20px;
          font-size: 14px;
        }
      }
      &.block2 {
        margin-top: 50px;
        @include flex_between_start;
        @media (max-width: $mob-screen) {
          margin-top: 20px;
          display: block;
        }
        .leader {
          flex-shrink: 0;
          margin-right: 117px;
          width: 300px;
          @media (max-width: 860px) {
            width: 240px;
            margin-right: 60px;
          }
          @media (max-width: $mob-screen) {
            width: 100%;
            margin-right: 0;
            margin-bottom: 20px;
          }
          .content {
            position: relative;
            &:before {
              display: block;
              content: "";
              width: 1px;
              background: rgba(22, 49, 112, 0.2);
              position: absolute;
              top: -28px;
              bottom: 0;
              right: -61px;
              @media (max-width: 860px) {
                right: -30px;
              }
              @media (max-width: $mob-screen) {
                display: none;
              }
            }
            .item {
              padding: 10px 0;
              border-bottom: 1px solid #eee;
              cursor: pointer;
              @include flex_between_center;
              &:first-child {
                padding-top: 0;
              }
              .label {
                @include flex_start_center;
                &:before {
                  flex-shrink: 0;
                  display: block;
                  content: "";
                  margin-right: 9px;
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  background: #163170;
                }
              }
              .name {
                padding-right: 13px;
              }
            }
          }
        }
        .office {
          flex-grow: 1;
        }
      }
      &.block3 {
        margin-top: 50px;
        @media (max-width: $mob-screen) {
          margin-top: 20px;
        }
        .sub_title {
          margin-top: 20px;
          padding: 10px 5px;
          border-bottom: 1px solid rgba(22, 49, 112, 0.2);
          line-height: 29px;
          font-size: 20px;
          color: #222;
          @media (max-width: $mob-screen) {
            margin-top: 10px;
            line-height: 29px;
            font-size: 16px;
          }
        }
        .content {
          margin: 0;
          padding-bottom: 20px;
          @include flex_start_start;
          flex-wrap: wrap;
          &:last-child {
            padding-bottom: 0;
          }
          @media (max-width: $mob-screen) {
            display: block;
            padding-bottom: 0;
          }
          .item {
            margin-top: 28px;
            width: 25%;
            box-sizing: border-box;
            padding-right: 13px;
            cursor: pointer;
            @include flex_start_center;
            @media (max-width: 860px) {
              width: 33%;
            }
            @media (max-width: $mob-screen) {
              margin-top: 14px;
              width: 100%;
            }
            &:before {
              flex-shrink: 0;
              display: block;
              content: "";
              margin-right: 9px;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #163170;
            }
          }
        }
      }
      &.block4 {
        margin-top: 50px;
        @media (max-width: $mob-screen) {
          margin-top: 20px;
        }
        .content {
          margin-top: 50px;
          @include flex_center_end;
          @media (max-width: 850px) {
            display: block;
          }
          @media (max-width: $mob-screen) {
            margin-top: 20px;
          }
          .address {
            margin: 5px 40px;
            line-height: 28px;
            font-size: 16px;
            color: #242424;
            white-space: nowrap;
            &:first-child {
              opacity: 0;
              @media (max-width: 1180px) {
                display: none;
              }
            }
            @media (max-width: 1190px) {
              margin: 5px 20px;
            }
            @media (max-width: 1130px) {
              margin: 5px;
            }
            @media (max-width: 850px) {
              margin: 10px 0;
            }
            @media (max-width: $mob-screen) {
              line-height: 20px;
              font-size: 12px;
            }
          }
          img {
            display: block;
            width: 390px;
            @media (max-width: $mob-screen) {
              width: 100%;
            }
          }
        }
      }
    }
    .tools {
      margin-top: 40px;
      @include flex_center_center;
      .tools_item {
        width: 155px;
        line-height: 49px;
        background: #f5f6f9;
        text-align: center;
        margin: 0 20px;
        font-size: 16px;
        color: #000;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss">
@for $i from 2 to 6 {
  .page_theme_#{$i} {
    .Team {
      .news {
        background: nth($bg_color, $i);
        .block {
          .title {
            border-bottom-color: nth($text_color, $i);
            div {
              color: nth($text_color, $i);
              border-bottom-color: nth($text_color, $i);
            }
          }
          .content {
            color: nth($text_color, $i);
          }
          &.block2 {
            .leader {
              .content {
                &:before {
                  background: nth($text_color, $i);
                }
                .item {
                  border-bottom-color: nth($text_color, $i);
                  .label {
                    &:before {
                      background: nth($text_color, $i);
                    }
                  }
                }
              }
            }
          }
          &.block3 {
            .sub_title {
              border-bottom-color: nth($text_color, $i);
              color: nth($text_color, $i);
            }
            .content {
              .item {
                &:before {
                  background: nth($text_color, $i);
                }
              }
            }
          }
          &.block4 {
            .content {
              .address {
                color: nth($text_color, $i);
              }
            }
          }
        }
        .tools {
          .tools_item {
            background: nth($bg_color, $i);
            color: nth($text_color, $i);
            border: 1px solid nth($text_color, $i);
          }
        }
      }
    }
  }
}
</style>